import ResponsiveTypography from '@/components/ui/responsive-typography';
import {env} from '@/config';
import {Box, Grid, Typography, useMediaQuery, useTheme} from '@mui/material';
import {useTranslation} from 'react-i18next';
import qrCodeSportJoe from '@/assets/images/sportjoe-link-qr.jpg';
import qrCodeSjOne from '@/assets/images/sjone-link-qr.jpg';

const EventParticipatingCard = () => {
  const {APP_VARIANT, DOWNLOAD_URL} = env;
  const {t} = useTranslation();
  const theme = useTheme();
  const isSmallerScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const qrCodeSource = APP_VARIANT === 'sjone' ? qrCodeSjOne : qrCodeSportJoe;

  return (
    <Grid
      item
      xs={12}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: 3,
        marginBottom: {xs: 1, sm: 0},
        flexDirection: 'column'
      }}
    >
      <Typography
        variant="h5"
        component="div"
        sx={{
          mx: 'auto'
        }}
      >
        {t('participating')}
      </Typography>
      {isSmallerScreen ? (
        <Box
          sx={{
            marginTop: 3,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mx: 'auto',
            textAlign: 'center'
          }}
        >
          <ResponsiveTypography larger>
            {t('download_app_info_part1')}
            <a href={DOWNLOAD_URL} target="_blank" rel="noopener noreferrer">
              {t('download_app_info_link')}
            </a>
            {t(`download_app_info_part2_${APP_VARIANT}`)}
          </ResponsiveTypography>
        </Box>
      ) : (
        <Box
          sx={{
            marginTop: 3,
            width: '85%',
            height: '85%',
            flexDirection: 'column',
            display: 'flex',
            alignItems: 'center',
            mx: 'auto'
          }}
        >
          <ResponsiveTypography mediumSmall>
            {t(`download_app_info_${APP_VARIANT}`)}
          </ResponsiveTypography>
          <img
            src={qrCodeSource}
            alt="QR Code"
            style={{maxWidth: '60%', height: 'auto', marginTop: 10}}
          />
        </Box>
      )}
    </Grid>
  );
};

export default EventParticipatingCard;
